import React, { createContext, useState } from 'react';
import { writeLocalStorage,readLocalStorage } from '../commons/localStorageManagement';

const initialValue = {
  actual_inscription: '',
  ignorePoll: false,
};

export const DataContext = createContext(initialValue);

const DataProvider = ({ children }) => {
  const [data, setData] = useState({...initialValue,actual_inscription: readLocalStorage('currentInscription','')});

  const dispatch = (newData) => {
    if('actual_inscription' in newData) writeLocalStorage('currentInscription',newData.actual_inscription)
    setData((prev) => ({ ...prev, ...newData }))
  };

  return (
    <DataContext.Provider value={{ allData: data, dispatch }}>
      {children}
    </DataContext.Provider>
  );
};

export default DataProvider;
